import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {ChangeEventHandler, FocusEventHandler, useCallback, useEffect, useMemo, useRef, useState} from 'react'
import {CFValue} from 'module/CustomField/type/CFType'
import {cssCFInput} from 'module/CustomField/style/cssCFInput'
import {css} from '@emotion/react'
import {adaptModelHexColorValue, ensureHexColorLenght, getColorsFromHexColorColumnValue} from 'module/CustomField/util/HexColorComponentUtil'
import {CF} from 'module/CustomField/util/CustomField'

export function CustomFieldHexColorComponent(props: CFComponentProps<CFValue>) {
	const {rawValue, setCb, model, cfDef} = props
	const ref = useRef<HTMLInputElement | null>(null)

	const [value, setValue] = useState<string>('')

	let v = rawValue
	if (v && (v + '')[0] === '#' && cfDef.length === 6) {
		v = CF.getValueFrom({...cfDef, length: 7}, model) as string | null
		v = !v ? v : (v + '').substring(1)
	}

	useEffect(() => {
		setValue(adaptModelHexColorValue(v))
	}, [v])

	const cssHexColor = useMemo(() => {
		const x = getColorsFromHexColorColumnValue(value)
		if (!x) return undefined
		return css`
			& input {
				background: ${x.background};
				color: ${x.color};
			}
		`
	}, [value])

	const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>((evt) => setValue(evt.target.value.replace('#', '')), [])
	const onFocus = useCallback<FocusEventHandler<HTMLInputElement>>((evt) => evt.target.select(), [])
	const onBlur = useCallback(() => {
		setCb(ensureHexColorLenght(value))
	}, [value, ref.current])
	return <div className={'CustomFieldHexColor'} css={cssHexColor}>
		<input
			css={cssCFInput}
			value={(value.startsWith('#') ? '' : '#') + value}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	</div>
}